import React, { useState } from 'react';

const Green = ({ cargoService,containerService, value, cargoID }) => {
    const initialCargoData = {
        id: cargoID,
        green: value ? 1 : 0,  
    };

    const [newCargo, setNewCargo] = useState(initialCargoData);

    const onChangeCargo = (event) => {

        const updatedGreenValue = event.target.checked ? 1 : 0;  

        const updatedCargo = {
            ...newCargo,
            green: updatedGreenValue,
        };

        console.log(updatedGreenValue); 
        setNewCargo(updatedCargo);
        cargoService.updateGreen(updatedCargo);


        cargoService.updateGreen(updatedCargo)
        .then(response => { 
            containerService.fetchList() 

        })
        .catch(error => {
            console.error(error);
        });



    };
 
    

    return (
        <input type="checkbox" checked={newCargo.green === 1} onChange={onChangeCargo} />
    );
};

export default Green;
